import { useEffect } from "react";

export default function SEO({ title, description, canonical, image, keywords, noIndex, type = "website" }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`) || document.querySelector(`meta[property="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        if (name.startsWith("og:") || name.startsWith("twitter:")) el.setAttribute("property", name);
        else el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", description);
    setMeta("keywords", keywords);
    setMeta("robots", noIndex ? "noindex,nofollow" : "index,follow");
    setMeta("og:title", title);
    setMeta("og:description", description);
    setMeta("og:type", type);
    setMeta("og:site_name", "Estem Sürücü Kursu");
    setMeta("og:locale", "tr_TR");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);

    if (image) {
      setMeta("og:image", image);
      setMeta("og:image:width", "1200");
      setMeta("og:image:height", "630");
      setMeta("twitter:image", image);
    }

    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
      link.href = canonical;
      setMeta("og:url", canonical);
    }
  }, [title, description, canonical, image, keywords, noIndex, type]);

  return null;
}
